<form autocomplete="off" [formGroup]="form" (ngSubmit)="validateForm()">
    <h4>Detalle de la pregunta</h4>
    <hr>
    <div class="col-12">
        <div class="form-group row">
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Pregunta</label>
                <input class="form-control form-input" type="text" placeholder="Pregunta" formControlName="label"
                    autocomplete="off" [class.is-invalid]="campoNoValido('label')">
                <small class="text-danger" *ngIf="campoNoValido('label')">Este campo es requerido</small>
            </div>
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Resumen</label>
                <textarea class="form-control form-input" type="text" placeholder="Resumen" formControlName="summary"
                    autocomplete="off" rows="3"></textarea>
            </div>
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Detalle</label>
                <textarea class="form-control form-input" type="text" placeholder="Detalle" formControlName="detail"
                    autocomplete="off" rows="3"></textarea>
            </div>
            <div class="textOnInput col-sm-6 col-md-3">
                <label class="form-label" for="inputText">Orden</label>
                <input class="form-control form-input" type="text" placeholder="Orden" formControlName="order"
                    autocomplete="off" [class.is-invalid]="campoNoValido('order')">
                <small class="text-danger" *ngIf="campoNoValido('order')">Este campo es requerido</small>
            </div>
            <div class="textOnInput col-sm-6 col-md-3">
                <label class="form-label">Tipo pregunta</label>
                <select class="form-control" name="" formControlName="idquestiontype">
                    <option class="form-control" [ngValue]="null">Seleccione un tipo</option>
                    <option *ngFor="let tq of typequestions" value="{{tq.id}}">
                        {{tq.label}}
                    </option>
                </select>
            </div>

            <div class="textOnInput col-sm-6 col-md-3">
                <label class="form-label">¿Es obligatorio?</label>
                <div class="label-container align-switch">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="switch3" formControlName="isRequired"
                            checked>
                    </div>
                </div>
            </div>

            <div class="textOnInput col-sm-6 col-md-3">
                <label class="form-label">Estado</label>
                <div class="label-container align-switch">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="switch2" formControlName="isActive" checked>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="questions.length > 0">
                <div class="col-sm-6 col-md-4" style="margin-top: 1rem;">
                    <div class="custom-control custom-switch" *ngIf="!form.get('isSectionBinding').value">
                        <input class="custom-control-input" type="checkbox" id="switch1"
                            formControlName="isQuestionBinding" (change)="resetQuestionBindingForm()">
                        <label class="custom-control-label" for="switch1">¿Vincula a alguna pregunta?</label>
                    </div>
                </div>
                <ng-container *ngIf="form.get('isQuestionBinding').value === true">
                    <div class="textOnInput col-sm-6 col-md-4">
                        <label class="form-label">Pregunta a vincular</label>
                        <select class="form-control" name="" formControlName="idtriggerquestion">
                            <option class="form-control" [ngValue]="null">Seleccione una pregunta</option>
                            <ng-container *ngFor="let q of questions">
                                <option *ngIf="svquestion.id !== q.id" value="{{q.id}}">
                                    {{q.label}}
                                </option>
                            </ng-container>
                        </select>
                    </div>
                </ng-container>
                <ng-container *ngIf="form.get('isQuestionBinding').value !== true">
                    <div class="col-sm-6 col-md-4"></div>
                    <div class="col-sm-6 col-md-4"></div>
                </ng-container>
                <br>
                <div class="col-sm-6 col-md-4" style="margin-top: 1rem;" *ngIf="!form.get('isQuestionBinding').value">
                    <div class="custom-control custom-switch">
                        <input class="custom-control-input" type="checkbox" id="switchSec"
                            formControlName="isSectionBinding" (change)="resetSectionBindingForm()">
                        <label class="custom-control-label" for="switchSec">¿Vincula a alguna sección?</label>
                    </div>
                </div>
                <ng-container *ngIf="form.get('isSectionBinding').value === true">
                    <div class="textOnInput col-sm-6 col-md-4">
                        <label class="form-label">Sección vinculada</label>
                        <select class="form-control" name="" formControlName="idtriggersection">
                            <option class="form-control" [ngValue]="null">Seleccione una sección</option>
                            <option *ngFor="let s of svsections" value="{{s.id}}">
                                {{s.title}}
                            </option>
                        </select>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="form.get('isQuestionBinding').value === true || form.get('isSectionBinding').value === true">
                    <div class="textOnInput col-sm-6 col-md-4">
                        <div class="row" style="display: flex;">
                            <ng-container *ngIf="form.get('isQuestionBinding').value === true"><label
                                    class="form-label">Respuesta que activa esta pregunta</label>
                            </ng-container>
                            <ng-container *ngIf="form.get('isSectionBinding').value === true"><label
                                    class="form-label">Respuesta que activa esta sección</label>
                            </ng-container>
                            <select class="form-control" name="" formControlName="idoption"
                                (change)="addLinkQuestions(svquestion.id, form.get('idoption').value, form.get('idtriggerquestion').value, form.get('idtriggersection').value)">
                                <ng-container *ngIf="options.length > 0">
                                    <option class="form-control" [ngValue]="null">Seleccione una opción</option>
                                    <option *ngFor="let o of options" value="{{o.id}}">
                                        {{o.label}}
                                    </option>
                                </ng-container>
                                <ng-container *ngIf="options.length == 0">
                                    <small class="text-danger">No se han encontrado opciones</small>
                                </ng-container>
                            </select>

                        </div>
                    </div>
                    <ng-container>
                        <div class="col-sm-3 col-md-4"></div>
                        <div class="col-sm-6 col-md-4">
                            <table class="table">
                                <thead class="thead-detail text-center">
                                    <tr>
                                        <th scope="col">Respuesta</th>
                                        <th scope="col">Pregunta enlazada</th>
                                        <th scope="col">Sección enlazada</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="tbody-detail" *ngFor="let lk of linkQuestions; let i = index;">
                                        <td>{{ lk.idoption }}</td>
                                        <td>{{ lk.idtriggerquestion }}</td>
                                        <td>{{ lk.idtriggersection }}</td>
                                        <td class="text-center"><a class="a-icon text-center"
                                                (click)="removeLinks(i)"><i class="fa fa-trash i-icon"></i></a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-3 col-md-4"></div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <div class="col-6 input-group">
                    <button type="submit" class="btn btn-outline-primary btn-block">
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="!hiddenMsg">
        <app-alert [message]="msg.message" [status]="msg.status"></app-alert>
    </ng-container>
</form>
